import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSnackbar } from "notistack";
import Dropzone from "react-dropzone-uploader";
import { Button, Paper } from "@material-ui/core";
import { getProjectInforme2 } from "../../services/projectFileServices";
import "react-dropzone-uploader/dist/styles.css";
//import styled from "styled-components";

const PanelFilesInforme2P = ({ projectSlug }) => {
  const apiEndPoint = process.env.REACT_APP_API_URL;

  const { enqueueSnackbar } = useSnackbar();

  const styles = {
    dropzone: { width: "23em", height: "12em" },
    dropzoneActive: {
      borderColor: "blue",
      inputContent: "Soltar el archivo",
    },
    inputLabel: {
      color: "#00aae4",
      fontFamily: "Tahoma",
      fontSize: "11px",
    },
  };
  //dropzoneMain
  //RESOLUCIÓN

  let [informe21, setInforme21] = useState(null);
  let [informe22, setInforme22] = useState(null);
  let [informe23, setInforme23] = useState(null);
  let [informe24, setInforme24] = useState(null);
  let [informe25, setInforme25] = useState(null);
  let [informe26, setInforme26] = useState(null);
  let [informe27, setInforme27] = useState(null);
  let [informe28, setInforme28] = useState(null);
  let [informe29, setInforme29] = useState(null);
  let [informe210, setInforme210] = useState(null);

  const getUploadParams = ({ meta }) => {
    return { url: `${apiEndPoint}/projects/${projectSlug}/informe2` };
  };

  // called every time a file's `status` changes
  const handleChangeStatusR = (
    { meta, remove, file },
    status,
    fileWithMeta
  ) => {
    if (status === "done") {
      //enqueueSnackbar(`${meta.name} fue subido correctamente! Detalle: ${fileWithMeta[0].xhr.response}`, { variant: 'success' });
      enqueueSnackbar(`${meta.name} fue subido correctamente!`, {
        variant: "success",
      });
      if (informe21 === null) {
        setInforme21(JSON.parse(fileWithMeta[0].xhr.response));
      } else if (informe22 === null) {
        setInforme22(JSON.parse(fileWithMeta[0].xhr.response));
      } else if (informe23 === null) {
        setInforme23(JSON.parse(fileWithMeta[0].xhr.response));
      } else if (informe24 === null) {
        setInforme24(JSON.parse(fileWithMeta[0].xhr.response));
      } else if (informe25 === null) {
        setInforme25(JSON.parse(fileWithMeta[0].xhr.response));
      } else if (informe26 === null) {
        setInforme26(JSON.parse(fileWithMeta[0].xhr.response));
      } else if (informe27 === null) {
        setInforme27(JSON.parse(fileWithMeta[0].xhr.response));
      } else if (informe28 === null) {
        setInforme28(JSON.parse(fileWithMeta[0].xhr.response));
      } else if (informe29 === null) {
        setInforme29(JSON.parse(fileWithMeta[0].xhr.response));
      } else if (informe210 === null) {
        setInforme210(JSON.parse(fileWithMeta[0].xhr.response));
      }
      remove();
    } else if (status === "aborted") {
      enqueueSnackbar(
        `${meta.name} no se subió! Detalle: ${fileWithMeta[0].xhr.response}`,
        { variant: "error" }
      );
    } else if (status === "error_file_size") {
      enqueueSnackbar(`Error! Detalle: Tamaño máximo permitido es 2MB.`, {
        variant: "error",
      });
    } else if (status === "error_upload") {
      enqueueSnackbar(
        `Error! Detalle: Tamaño máximo permitido es 2MB y debe ser PDF.`,
        { variant: "error" }
      );
    } else if (status === "rejected_file_type") {
      enqueueSnackbar(
        `${meta.name} no se subió! Detalle: Solo se aceptan archivos en formato PDF`,
        { variant: "error" }
      );
    }
  };

  useEffect(() => {
    setInforme21("null");
    setInforme22("null");
    setInforme23("null");
    setInforme24("null");
    setInforme25("null");
    setInforme26("null");
    setInforme27("null");
    setInforme28("null");
    setInforme29("null");
    setInforme210("null");

    const populateinforme2 = async () => {
      const { data: project } = await getProjectInforme2(projectSlug);
      //setInforme1(project.informe1);
      setInforme21(project.informe21);
      setInforme22(project.informe22);
      setInforme23(project.informe23);
      setInforme24(project.informe24);
      setInforme25(project.informe25);
      setInforme26(project.informe26);
      setInforme27(project.informe27);
      setInforme28(project.informe28);
      setInforme29(project.informe29);
      setInforme210(project.informe210);
    };
    populateinforme2();
  }, [projectSlug]);

  return (
    <>
      <Paper className="paper">
        <h2>Informe Semestral (Agosto - Diciembre) </h2>
        <Dropzone
          getUploadParams={getUploadParams}
          onChangeStatus={handleChangeStatusR}
          autoUpload={false}
          maxFiles={1}
          multiple={false}
          canCancel={false}
          styles={styles}
          inputContent="Arrastrar aquí el PDF para subirlo"
          maxSizeBytes={20000000} // 20MB
          accept="application/pdf"
          //acceptedFiles = ".zip, .pdf"
        />

        {informe21 !== null ? (
          <Link
            style={{ textDecoration: "none" }}
            to={{
              pathname: `/proyectos/` + projectSlug + `/informe2`,
              state: {
                informe1: informe21,
                informe2: informe22,
                informe3: informe23,
                informe4: informe24,
                informe5: informe25,
                informe6: informe26,
                informe7: informe27,
                informe8: informe28,
                informe9: informe29,
                informe10: informe210,
              },
            }}
          >
            <br />
            <Button
              variant="contained"
              color="primary"
              style={{ marginTop: ".2em" }}
            >
              Abrir Informes Semestrales
            </Button>
          </Link>
        ) : (
          <p>
            <br /> No existe ningún archivo
          </p>
        )}
      </Paper>
    </>
  );
};

export default PanelFilesInforme2P;
